// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container_2UZXo"};